import axiosInstance from './axios';

export const reviewService = {
  list: async (params = {}) => {
    const response = await axiosInstance.get('/reviews', { params });
    return response.data;
  },

  approve: async (id) => {
    const response = await axiosInstance.post(`/reviews/${id}/approve`);
    return response.data;
  },

  reject: async (id, adminNotes = '') => {
    const response = await axiosInstance.post(`/reviews/${id}/reject`, {
      admin_notes: adminNotes,
    });
    return response.data;
  },
};
